import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import DateTime from 'react-datetime';
import classnames from 'classnames';
import moment from 'moment';
//
import { CalendarIcon, DatePickerIcon } from 'components';

import './date-picker.scss';
import './date-picker-position.scss';
import styles from './DatePicker.module.scss';

const getMaskedInput = (props) => (
  <MaskedInput
    {...props}
    mask={[
      /[0-1]/,
      /[0-9]/,
      '/',
      /[0-3]/,
      /[0-9]/,
      '/',
      /[1-2]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
    ]}
    guide={!props.isPatientForm}
    className="date-picker__input"
    name={props.name}
    onChange={(event) => {
      if (props.value === event.target.value) {
        return;
      }
      props.onChange(event);
    }}
  />
);

export const DatePickerSimpleField = (props) => {
  const {
    label,
    dateFormat,
    timeFormat,
    onChange,
    value: propsValue,
    position,
    onFocus,
    onBlur,
    name,
    disableDatepicker,
    placeholderDatepicker,
    additionalBottom,
    isPatientForm,
    blockBefore,
    blockAfter,
    inputWrapperClassName,
  } = props;

  const [valueState, changeValueState] = useState(false);
  const [calendarOpenState, toggleCalendarOpenState] = useState(false);

  const isValidDate = (currentDate) => {
    const beforeLimit = blockBefore ? moment(blockBefore, 'MM/DD/YYYY') : null;
    const afterLimit = blockAfter ? moment(blockAfter, 'MM/DD/YYYY') : null;

    if (beforeLimit && currentDate.isBefore(beforeLimit, 'day')) {
      return false;
    }
    if (afterLimit && currentDate.isAfter(afterLimit, 'day')) {
      return false;
    }
    return true;
  };

  return (
    <label
      className={
        isPatientForm
          ? classnames(
              styles['date-picker-input-wrapper'],
              inputWrapperClassName,
            )
          : classnames(
              'input-component date-picker-wrapper',
              `${additionalBottom ? 'add_bottom' : ''}`,
              { _open: calendarOpenState },
              `_${position}`,
            )
      }
    >
      {label && (
        <span
          className={classnames('input-component__label', {
            _disabled: disableDatepicker,
          })}
        >
          {label}
        </span>
      )}
      <DateTime
        key={name}
        className={position ? `_${position}` : '_left'}
        inputProps={{
          placeholder: placeholderDatepicker,
          disabled: disableDatepicker,
          autoComplete: 'off',
          onClick: (event) => {
            if (!calendarOpenState) {
              toggleCalendarOpenState(true);
            }
          },
        }}
        renderInput={(props) =>
          getMaskedInput({ ...props, name, isPatientForm })
        }
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        value={propsValue || valueState}
        onFocus={() => {
          onFocus();
        }}
        onBlur={() => {
          const inputsArray = document.getElementsByName(name);
          if (inputsArray && inputsArray[0]) {
            inputsArray[0].blur();
          }
          toggleCalendarOpenState(false);
          onBlur();
        }}
        onChange={(changedValue) => {
          if (!changedValue) {
            onChange('');
            return changeValueState('');
          }

          if (
            typeof changedValue === 'string' &&
            !moment(changedValue, dateFormat, true).isValid()
          ) {
            return;
          }
          const date =
            typeof changedValue === 'string'
              ? moment(changedValue, dateFormat)
              : changedValue;

          changeValueState(date);
          onChange(date.format(dateFormat));
          setTimeout(() => toggleCalendarOpenState(false), 0);
        }}
        isValidDate={isValidDate}
      />
      {isPatientForm ? (
        <DatePickerIcon />
      ) : (
        <CalendarIcon
          width="12px"
          height="11px"
          className={classnames('date-picker__icon', {
            _open: calendarOpenState,
            _disabled: disableDatepicker,
          })}
        />
      )}
    </label>
  );
};

DatePickerSimpleField.propTypes = {
  label: PropTypes.string,
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  value: PropTypes.any,
  position: PropTypes.string, // left, right
  disableDatepicker: PropTypes.bool,
  isPatientForm: PropTypes.bool,
  blockBefore: PropTypes.instanceOf(Date),
  blockAfter: PropTypes.instanceOf(Date),
  inputWrapperClassName: PropTypes.string,
};

DatePickerSimpleField.defaultProps = {
  label: '',
  dateFormat: 'MM/DD/YYYY',
  timeFormat: false,
  onChange: () => {},
  value: '',
  position: 'left',
  disableDatepicker: false,
  isPatientForm: false,
};
